export const reasonsForLine = (masters, line) =>
  (masters.defect_reasons || []).filter((r) => r.active && (!r.line_id || r.line_id === line?.id) && (!r.section_id || r.section_id === line?.section_id));

const scoped = (items, line, modelId) =>
  (items || []).filter((j) => j.active && j.section_id === line?.section_id && (!j.line_id || j.line_id === line?.id) && (!j.model_id || `m:${j.model_id}` === modelId || j.model_id === modelId));

export function capacityFor(masters, line, model) {
  if (!line || !model) return null;
  const jigs = scoped(masters.jigs_fixtures, line, model.value || model.id);
  const tools = scoped(masters.tools, line, model.value || model.id);
  const jigCap = jigs.length ? Math.min(...jigs.map((j) => j.capacity_uph)) : null;
  const toolCap = tools.length ? Math.min(...tools.map((t) => t.capacity_uph)) : null;
  const caps = [{ src: "Model UPH", cap: model.uph }, jigCap != null && { src: "Jig/Fixture", cap: jigCap }, toolCap != null && { src: "Tool", cap: toolCap }].filter(Boolean);
  const bottleneck = caps.reduce((a, b) => (b.cap < a.cap ? b : a), caps[0]);
  return { jigCap, toolCap, bottleneck, jigs, tools };
}
